import React from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import CrauselBanner from './components/CrauselBanner';

import ContactUs from './pages/ContactUs';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from './pages/Home';
import AboutUs from './pages/About';
import Products from './pages/Product';

function App() {
  return (
    <Router>
      <Header />

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <CrauselBanner />
              <Home/>
            </>
          }
        />
        <Route path="/produce" element={<Products />} />
        <Route path="/about" element={<AboutUs />} />
        {/* Contact Page */}
        <Route path="/contactus" element={<ContactUs />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
